import type { OrderData } from './computeOrderData'
import type { BulkViewData } from './types'

export function computeInitialOrderData(firstOrderData: OrderData): BulkViewData {
  const {
    priority,
    company,
    eligibility,
    serviceTime,
    vehicleId,
    phone,
    email,
    notes,
    tagsIn,
    tagsOut,
    violations,
    timeWindows,
  } = firstOrderData

  return {
    priority,
    company,
    eligibility,
    loads: {
      value: { ...firstOrderData.loads },
      hasAlsoMixedValues: false,
    },
    serviceTime,
    vehicleId,
    phone,
    email,
    notes,
    violations: new Set(violations),
    tagsIn: {
      value: tagsIn,
      hasAlsoMixedValues: false,
    },
    tagsOut: {
      value: tagsOut,
      hasAlsoMixedValues: false,
    },
    timeWindows,
  }
}
